export default __webpack_public_path__ + "static/media/uniphore.3b061310.svg";